export const TIPOS = [
    {id: 'todo', name: 'Todo'},
    {id: 'CEL', name: 'Cheques Electrónicos'},
    {id: 'TRF', name: 'Transferencias Bancarias'},
    {id: 'AEF', name: 'Acreditaciones en Efectivo'},
    {id: 'PREPAGO', name: 'Prepagos'},
];